<template>
  <div class="card h-100 mb-3 card-light text-lg-start">
    <div class="content-library" :aria-label="item.title" >
      <a :href="item.link" :target="item.target" class="image-wrap w-100 justify-content-center p-3">
        <img :src="item.image.url" :alt="item.image.alt" />
      </a>
    </div>
    <div class="card-body d-flex flex-column py-3">
      <div v-if="item.subtitle != ''" class="text-uppercase text-primary fw-bold">{{ item.subtitle }}</div>
      <h3 class="h4 mb-3 text-capitalize">
        <a :href="item.link" class="text-black d-flex justify-content-between" :target="item.target">
          {{ item.title }}
        </a>
      </h3>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['item']
  }
</script>
